import globalstyles from '../../global.module.scss';
import styles from './styles.module.scss';

import { supabase } from '../../supabase';
import { getUser } from '../../api';

import { Flex, Button, Popconfirm } from 'antd';

import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

const welcomeMessage = (username: string) => {
  let options = [`Welcome back, ${username}!`, `Hello, ${username}!`, 'Quack!'];

  return options[Math.floor(Math.random() * options.length)];
};

export const HomeScreen: React.FC = () => {
  const nav = useNavigate();
  const { data: user } = useQuery(['user'], getUser);

  const confirm = () => {
    supabase.auth.signOut();
  };

  const enter = () => {
    nav('/main');
  };

  return (
    <div className={globalstyles.Center} style={{ height: '100vh' }}>
      <Popconfirm
        title="Signout"
        description="Are you sure you want to signout?"
        onConfirm={confirm}
        okText="Yes"
        cancelText="No"
        placement="rightBottom"
      >
        <Button type="text" className={styles.SignoutButton}>
          Signout
        </Button>
      </Popconfirm>

      <Flex vertical gap={'4em'}>
        <h1 className={globalstyles.Title}>Duck Tycoon</h1>
        <h3 className={globalstyles.Subtitle}>{welcomeMessage(user?.username ?? 'duck')}</h3>
        <Button type="primary" shape="round" size="large" onClick={enter}>
          Enter
        </Button>
      </Flex>
    </div>
  );
};
